<template>
  <div class="main-page process">
    <Menus title="进度查询"
           :home="true">
      <a @click="$router.push('/service/6')"
         href="javascript:;"
         slot="left-link" />
    </Menus>
    <div class="container-flex">
      <div class="process-list">
        <div v-if="showDefalt "
             class="pageStateTip">
          <div class="imgs">
            <img src="/img/ui/legal-default.png"
                 alt>
          </div>
          <div class="ht">
            <h1>您还没有申请人民调解</h1>
          </div>
          <div class="cancelResevation">
            <p>点击下方按钮免费开始申请</p>
            <router-link to="/mediation/apply"
                         class="btns">
              在线申请人民调解
            </router-link>
          </div>
        </div>
        <template v-else>
          <div v-for="(item,index) in list"
               :key="'key-'+index"
               class="item">
            <div class="content">
              <div class="name">
                {{ getType(item.jftype) }}调解申请
              </div>

              <div class="time">
                <p>
                  <span>申请人：{{ item.sqrname }}</span> &nbsp; &nbsp; &nbsp; &nbsp; <span>被申请人：{{ item.bsqrname }}</span><br>
                </p>
                <p>
                  申请时间：{{ getTime(item.create_time) }}
                </p>
              </div>
              <div class="info">
                <p>
                  办理状态： <span class="fc-blue">{{ item.status.content }}</span><br>
                  拒绝原因： <span>{{ item.status.reason ||'-' }}</span>
                </p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import jftype from '../../datas/js/jftype.json'
import { MEDIATION_INQUIRE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  data () {
    return {
      status: 1,
      list: [],
      showDefalt: 0
    }
  },
  mounted () {
    let userid = this.$store.state.user.wechatUinfo.userid
    this.$loading.show()
    this.getList(userid)
    this.$root.getStatistics(MEDIATION_INQUIRE)
  },
  methods: {
    /**
     * 获取列表
     * @param {Strong} userid 用户id
     */
    async getList (userid) {
      const { results, msg, status } = await this.$get(`https://yn.12348.laway.cn/api/mediate/list/?user_id=${userid}`)
      if (!status) {
        console.log('错误：' + msg)
        return
      }
      this.$loading.hide()
      console.log(results)
      if (results.data.length) {
        this.list = results.data
      } else {
        this.showDefalt = 1
      }
    },
    getTime (value) {
      return this.$moment(value).format('YYYY-MM-DD  HH:mm:ss')
    },
    getType (value) {
      console.log(value)
      let typeName = ''
      for (let i = 0; i < jftype.length; i++) {
        const item = jftype[i]
        if (value === item.id) {
          typeName = item.text
        }
      }
      return typeName
    }
  }
}
</script>
